import { z } from 'zod'

import {
  organizationRelationshipCreateArgsSchema,
  organizationRelationshipListQuerySchema,
  organizationRelationshipListResponseSchema,
  organizationRelationshipListArgsSchema,
  organizationRelationshipPermissionOptionsSchema,
  organizationRelationshipPermissionSchema,
  organizationRelationshipPublicPromoterResponseSchema,
  organizationRelationshipPublicPromoterSchema,
  organizationRelationshipSchema,
  organizationRelationshipUpdateByIdArgsSchema,
} from './schemas/organizationRelationship'
import { Permissions, PermissionType } from './constants/permission'
import { OrganizationRelationshipKind } from './constants/organizationRelationshipKind'

export type OrganizationRelationship = z.infer<
  typeof organizationRelationshipSchema
>

export type OrganizationRelationshipPermission = z.infer<
  typeof organizationRelationshipPermissionSchema
>

export type OrganizationRelationshipCreateArgs = z.infer<
  typeof organizationRelationshipCreateArgsSchema
>

export type OrganizationRelationshipUpdateByIdArgs = z.infer<
  typeof organizationRelationshipUpdateByIdArgsSchema
>

export type OrganizationRelationshipListArgs = z.infer<
  typeof organizationRelationshipListArgsSchema
>

export type OrganizationRelationshipListQuery = z.infer<
  typeof organizationRelationshipListQuerySchema
>

export type OrganizationRelationshipListResponse = z.infer<
  typeof organizationRelationshipListResponseSchema
>

export type OrganizationRelationshipPermissionOptions = z.infer<
  typeof organizationRelationshipPermissionOptionsSchema
>

export type OrganizationRelationshipPublicPromoter = z.infer<
  typeof organizationRelationshipPublicPromoterSchema
>

export type OrganizationRelationshipPublicPromoterResponse = z.infer<
  typeof organizationRelationshipPublicPromoterResponseSchema
>

/**
 * Permission types allowed for promoters (organization relationships)
 */
const PROMOTERS_PERMISSION_TYPES = {
  READ_RESERVATIONS: Permissions[PermissionType.READ_RESERVATIONS],
  WRITE_RESERVATIONS: Permissions[PermissionType.WRITE_RESERVATIONS],
  READ_GUESTLISTS: Permissions[PermissionType.READ_GUESTLISTS],
  WRITE_GUESTLISTS: Permissions[PermissionType.WRITE_GUESTLISTS],
  // VIEW_RESERVATIONS_MAP: Permissions[PermissionType.VIEW_RESERVATIONS_MAP],
  // UPDATE_RESERVATION_TABLES:
  //   Permissions[PermissionType.UPDATE_RESERVATION_TABLES],
  // CREATE_PAYMENT_LINKS: Permissions[PermissionType.CREATE_PAYMENT_LINKS],
}

const PARTNER_ORG_PERMISSION_TYPES = {
  MANAGE_ORG_API_KEYS: Permissions[PermissionType.MANAGE_ORG_API_KEYS],
  WRITE_ORGANIZATION: Permissions[PermissionType.WRITE_ORGANIZATION],
}

export const getAllowedOrganizationRelationshipPermissions = (
  kind: OrganizationRelationshipKind = OrganizationRelationshipKind.PROMOTER
) => {
  if (kind === OrganizationRelationshipKind.PARTNER) {
    return [
      ...Object.values(PROMOTERS_PERMISSION_TYPES),
      ...Object.values(PARTNER_ORG_PERMISSION_TYPES),
    ]
  }

  return Object.values(PROMOTERS_PERMISSION_TYPES)
}
